import {
    DELETE_SUBSCRIPTION,
    DELETE_SUBSCRIPTION_SUCCESS,
    DELETE_SUBSCRIPTION_FAIL,
    FETCH_LIMITS,
    FETCH_LIMITS_FAIL,
    FETCH_LIMITS_SUCCESS,
    FETCH_SUBSCRIPTION,
    FETCH_SUBSCRIPTION_FAIL,
    FETCH_SUBSCRIPTION_SUCCESS,
    PUT_SUBSCRIPTION,
    PUT_SUBSCRIPTION_SUCCESS,
    PUT_SUBSCRIPTION_FAIL,
    POST_SUBSCRIPTION,
    POST_SUBSCRIPTION_FAIL,
    POST_SUBSCRIPTION_SUCCESS,
    POST_SUBSCRIPTION_CARD,
    POST_SUBSCRIPTION_CARD_FAIL,
    POST_SUBSCRIPTION_CARD_SUCCESS,
} from './reducer';

export const deleteSubscription = (subscription) => ({
    payload: {
        request: {
            method: 'delete',
            url: `/subscriptions/${subscription}`,
        },
    },
    types: [
        DELETE_SUBSCRIPTION,
        DELETE_SUBSCRIPTION_SUCCESS,
        DELETE_SUBSCRIPTION_FAIL,
    ],
});

export const fetchSubscription = () => ({
    payload: {
        request: {
            method: 'get',
            url: '/subscriptions/stripe',
        },
    },
    types: [
        FETCH_SUBSCRIPTION,
        FETCH_SUBSCRIPTION_SUCCESS,
        FETCH_SUBSCRIPTION_FAIL,
    ],
});

export const postSubscription = (data) => ({
    payload: {
        request: {
            data,
            method: 'post',
            params: { embeds: 'company.users' },
            url: '/subscriptions',
        },
    },
    types: [
        POST_SUBSCRIPTION,
        POST_SUBSCRIPTION_SUCCESS,
        POST_SUBSCRIPTION_FAIL,
    ],
});

export const putSubscription = (subscriptionId, data) => ({
    payload: {
        request: {
            data,
            method: 'put',
            params: { embeds: 'company.users' },
            url: `/subscriptions/${subscriptionId}`,
        },
    },
    types: [
        PUT_SUBSCRIPTION,
        PUT_SUBSCRIPTION_SUCCESS,
        PUT_SUBSCRIPTION_FAIL,
    ],
});

export const updateCard = (paymentMethod) => ({
    payload: {
        request: {
            data: { paymentMethod: paymentMethod.id },
            method: 'post',
            params: { embeds: 'activeSubscription' },
            url: '/subscriptions/card',
        },
    },
    types: [
        POST_SUBSCRIPTION_CARD,
        POST_SUBSCRIPTION_CARD_SUCCESS,
        POST_SUBSCRIPTION_CARD_FAIL,
    ],
});

export const fetchLimits = () => ({
    payload: {
        request: {
            method: 'get',
            url: '/subscriptions/limits',
        },
    },
    types: [
        FETCH_LIMITS,
        FETCH_LIMITS_SUCCESS,
        FETCH_LIMITS_FAIL,
    ],
});
